import React, { useEffect, useState } from "react";
import api from "../../utils/apiClient";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Spin, Modal, Input } from "antd";
import "../../style/AllCarsAdmin.css";

function AdSpaceRequests() {
  const { authToken, logout } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [requests, setRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [reasonModal, setReasonModal] = useState({ open: false, requestId: null, value: "" });

  useEffect(() => {
    const fetchData = async () => {
      if (!authToken) {
        navigate("/");
        return;
      }
      try {
        const userRes = await api.get("usuario/getbyToken");
        setUsername(userRes.data.nombre);
        const res = await api.get("pendingAdSpaces");
        setRequests(res.data || []);
      } catch (error) {
        console.error("Error fetching ad space requests", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [authToken, navigate]);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleApprove = async (id) => {
    try {
      await api.patch(`pendingAdSpaces/approve/${id}`, {});
      setRequests((prev) => prev.filter((item) => item._id !== id));
      if (selectedRequest?._id === id) {
        setSelectedRequest(null);
      }
    } catch (error) {
      console.error("Error approving request", error);
    }
  };

  const openRejectModal = (id) => {
    setReasonModal({ open: true, requestId: id, value: "" });
  };

  const handleReject = async () => {
    const { requestId, value } = reasonModal;
    try {
      await api.patch(`pendingAdSpaces/reject/${requestId}`, { reason: value });
      setRequests((prev) => prev.filter((item) => item._id !== requestId));
      if (selectedRequest?._id === requestId) {
        setSelectedRequest(null);
      }
    } catch (error) {
      console.error("Error rejecting request", error);
    } finally {
      setReasonModal({ open: false, requestId: null, value: "" });
    }
  };

  const handleCancelReject = () => {
    setReasonModal({ open: false, requestId: null, value: "" });
  };

  const renderStatus = (req) => {
    if (!req) return "";
    const status = req.status || "pending";
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a">
          <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-all adspace-requests-page">
            <AdminSidebarDropdown onLogout={handleLogout} />
            <p className="main-admin-title-a">Solicitudes de espacios publicitarios</p>
            {loading ? (
              <div className="loading-container">
                <Spin size="large" />
              </div>
            ) : (
              <div className="requests-layout">
                <div
                  className="overview-container adspace-requests-list"
                  style={{ maxHeight: "700px", overflow: "auto" }}
                >
                  {requests.map((req) => (
                    <div
                      className="overview-item"
                      key={req._id}
                      onClick={() => setSelectedRequest(req)}
                    >
                      <p className="request-user-name">{req.usuario?.nombre || "Usuario"}</p>
                      <p className="request-user-email">{req.usuario?.correo || "-"}</p>
                      <div style={{ display: "flex", gap: "0.5rem", marginLeft: "auto", flexShrink: 0 }}>
                        <button className="red-button" onClick={(e) => { e.stopPropagation(); handleApprove(req._id); }}>
                          Aprobar
                        </button>
                        <button className="red-button" onClick={(e) => { e.stopPropagation(); openRejectModal(req._id); }}>
                          Rechazar
                        </button>
                      </div>
                    </div>
                  ))}
                  {requests.length === 0 && (
                    <p className="no-notifications">No hay solicitudes pendientes</p>
                  )}
                </div>
                <div className="details-panel">
                  {selectedRequest ? (
                    <div className="request-details">
                      <h3>{selectedRequest.titulo}</h3>
                      <p><strong>Duración:</strong> {selectedRequest.duracionDias} día(s)</p>
                      <p><strong>Estado:</strong> {renderStatus(selectedRequest)}</p>
                      <p><strong>Usuario:</strong> {selectedRequest.usuario?.nombre}</p>
                      <p><strong>Correo:</strong> {selectedRequest.usuario?.correo}</p>
                      {selectedRequest.banner && (
                        <img
                          src={selectedRequest.banner}
                          alt={selectedRequest.titulo}
                          style={{ width: "100%", borderRadius: "12px", marginTop: "1rem" }}
                        />
                      )}
                    </div>
                  ) : (
                    <p className="no-notifications">Selecciona una solicitud para ver los detalles.</p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
      <Modal
        title="Rechazar solicitud"
        open={reasonModal.open}
        onOk={handleReject}
        onCancel={handleCancelReject}
        okText="Confirmar"
        cancelText="Cancelar"
      >
        <p>Indica el motivo del rechazo (opcional).</p>
        <Input.TextArea
          rows={4}
          value={reasonModal.value}
          onChange={(e) => setReasonModal((prev) => ({ ...prev, value: e.target.value }))}
          placeholder="Motivo"
        />
      </Modal>
    </>
  );
}

export default AdSpaceRequests;
